"use strict";

export default {
  setUser(state, payload) {
    state.users = payload;
  },
};
